import { useEffect, useMemo } from "react";

import { MessagesAnalyticsScreen } from "@/constants/analytics/Analytics";
import { router } from "@/crossPlatform/expo-router";
import useChatChannelContext from "@/hooks/useChatChannels";
import { useAnalytics } from "@/services/Analytics";
import type { MessagesInformationSection } from "@/ui/components/messages/ChannelInformationSection";
import ChannelInformationSection, {
  SectionInfo,
} from "@/ui/components/messages/ChannelInformationSection";
import MessagesInformationFooter from "@/ui/components/messages/MessagesInformationFooter";
import ModalTitleHeader from "@/ui/composed/modal/ModalTitleHeader";
import { FlatList } from "@/ui/layout";
import ModalLayout from "@/ui/layout/ModalLayout";

const baseTestID = "messages-information";

const Modal = () => {
  const { admissionsChannels, groupChannels, individualChannels } =
    useChatChannelContext();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(MessagesAnalyticsScreen.AboutMessages);
  }, [trackPageView]);

  const listItems = useMemo<MessagesInformationSection[]>(() => {
    const initialItems: MessagesInformationSection[] = [];

    if (admissionsChannels.length > 0) {
      initialItems.push({
        channels: admissionsChannels,
        sectionInfo: SectionInfo.admissions,
      });
    }

    if (groupChannels.length > 0) {
      initialItems.push({
        channels: groupChannels,
        sectionInfo: SectionInfo.group,
      });
    }

    if (individualChannels.length > 0) {
      initialItems.push({
        channels: individualChannels,
        sectionInfo: SectionInfo.individual,
      });
    }

    return initialItems;
  }, [admissionsChannels, groupChannels, individualChannels]);

  return (
    <ModalLayout
      isListView
      renderHeader={() => {
        return (
          <ModalTitleHeader
            onDismiss={() => router.dismiss()}
            testID={baseTestID}
            title="About Messages"
          />
        );
      }}
    >
      <FlatList
        data={listItems}
        ListFooterComponent={<MessagesInformationFooter testID={baseTestID} />}
        renderItem={({ item }) => {
          return (
            <ChannelInformationSection
              channels={item.channels}
              sectionInfo={item.sectionInfo}
            />
          );
        }}
        testID={baseTestID}
      />
    </ModalLayout>
  );
};

// eslint-disable-next-line import-x/no-unused-modules -- Modal/Tab/TabLayout/Screen/Home get used in expo routing but in a way that TypeScript can not infer
export default Modal;
